/**
 * @generated SignedSource<<2f0e7f812c94fa966a2076bdee0f639a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbs_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_item" | "PdpSharedBlurbDesignYourOwn_item" | "PdpSharedBlurbLeadTime_item" | "PdpSharedBlurbRareFind_item" | "useRenderBlurbs_item">;
  readonly " $fragmentType": "PdpRespSidebarBlurbs_item";
};
export type PdpRespSidebarBlurbs_item$key = {
  readonly " $data"?: PdpRespSidebarBlurbs_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbs_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isSiderailRedesignVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbs_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useRenderBlurbs_item"
    },
    {
      "condition": "isSiderailRedesignVariant",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedBlurbLeadTime_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedBlurbDesignYourOwn_item"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpSharedBlurbRareFind_item"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbShipping_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "b883dd70d377df9198ec77f78252a387";

export default node;
